export default __webpack_public_path__ + "static/media/sia-2.855c71b8.webp";